import { render, staticRenderFns } from "./ModalCreateWallet.vue?vue&type=template&id=6c1c6a32&scoped=true&"
import script from "./ModalCreateWallet.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ModalCreateWallet.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ModalCreateWallet.vue?vue&type=style&index=0&id=6c1c6a32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c6a32",
  null
  
)

export default component.exports